var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_671_8755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57129 0C4.60839 0 0.571289 4.0371 0.571289 9C0.571289 13.9629 4.60839 18 9.57129 18C14.5342 18 18.5713 13.9622 18.5713 9C18.5713 4.0378 14.5342 0 9.57129 0ZM9.57129 16.6057C5.37803 16.6057 1.96555 13.194 1.96555 9C1.96555 4.80604 5.37803 1.39426 9.57129 1.39426C13.7646 1.39426 17.177 4.80604 17.177 9C17.177 13.194 13.7653 16.6057 9.57129 16.6057Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0572 8.24055H10.2686V5.45203C10.2686 5.06721 9.95702 4.75488 9.57149 4.75488C9.18597 4.75488 8.87434 5.06721 8.87434 5.45203V8.24055H6.08582C5.7003 8.24055 5.38867 8.55288 5.38867 8.9377C5.38867 9.32252 5.7003 9.63485 6.08582 9.63485H8.87434V12.4234C8.87434 12.8082 9.18597 13.1205 9.57149 13.1205C9.95702 13.1205 10.2686 12.8082 10.2686 12.4234V9.63485H13.0572C13.4427 9.63485 13.7543 9.32252 13.7543 8.9377C13.7543 8.55288 13.4427 8.24055 13.0572 8.24055Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_671_8755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.571289)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.cc0fb7b6dc4fffc47d6b2c0bd4b28ab5.svg";
export { ForwardRef as ReactComponent };